import React from 'react';
import PropTypes from 'prop-types';

import ColumnHeader, { SortType } from '../../ColumnHeader';

import styles from './playersListSortable.scss';

const Header = (props) => {
    const { sortParam, sortType, handleSortClick } = props;

    return (
        <div className={`${styles.headers} d-none d-md-flex`}>
            <div className="flex-grow">
                <div className="row">
                    <div className={`col-5 ${styles.headerColumn}`}>
                        <ColumnHeader
                            isSortable
                            columnName="Name"
                            isSelected={sortParam === 'name'}
                            sortType={sortType}
                            initialSort={SortType.ASC}
                            onClick={(selectedSortType) => handleSortClick('name', selectedSortType)}
                        />
                    </div>
                    <div className={`col-7`}>
                        <div className="d-grid w-100" style={{ gridTemplateColumns: '1fr 1fr' }}>
                            <div className={`${styles.headerColumn}`}>
                                <ColumnHeader
                                    isSortable
                                    columnName="Singles"
                                    isSelected={sortParam === 'singlesRating'}
                                    sortType={sortType}
                                    onClick={(selectedSortType) => handleSortClick('singlesRating', selectedSortType)}
                                />
                            </div>
                            <div className={`${styles.headerColumn}`}>
                                <ColumnHeader
                                    isSortable
                                    columnName="Doubles"
                                    isSelected={sortParam === 'doublesRating'}
                                    sortType={sortType}
                                    onClick={(selectedSortType) => handleSortClick('doublesRating', selectedSortType)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bookmark" />
        </div>
    );
};

Header.propTypes = {
    sortParam: PropTypes.string.isRequired,
    sortType: PropTypes.string.isRequired,
    handleSortClick: PropTypes.func.isRequired,
};

export default Header;
